import styled from 'styled-components';
import { BLACK, PRIMARY, HOVER_ITEM_COLOR, WHITE, BACKGROUND_COLOR } from '../../utils/colors';
import { Col, Container, Button, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const HeaderNavArea = styled(Container)`
  margin: 0 auto;
  padding: 10px 50px;
  background-color: ${WHITE};
  position: fixed;
  left: 0;
  z-index: 9999;
  top: 0;
  color: ${BLACK};
  font-family: 'FigtreeBold', 'sans-serif';
  box-shadow: 0 3px 8px rgba(0,0,0,.2);
`

export const HeaderColumn = styled(Col)`
  display: flex;
  align-items: center; 
  justify-content: center;
  @media (max-width: 1070px) {
    justify-content: space-between;
  }
`

export const HeaderLogoMobile = styled.div`
  color: inherit;
  font-size: 25px;
  text-decoration: none;
  height: 70px;
  display: none;

  @media (max-width: 1070px) {
    display: block;
    cursor: pointer;
  }
`

export const HeaderLogo = styled.div`
  color: inherit;
  font-size: 25px;
  text-decoration: none;
  height: 70px;
  cursor: pointer;

  @media (max-width: 1070px) {
    display: none;
  }
`

export const HeaderLogoImage = styled.img`
  height: inherit;
  width: inherit;
  object-fit: cover;
`

export const HeaderMenuList = styled.ul`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin-top: 0;
  margin-bottom: 0;
  gap: 8px;
`

export const MenuItemLink = styled.a`
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
  text-align: left;
  padding: 0.7rem 2rem;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }
`

export const MenuItemLinkMobile = styled.a`
  display: block;
  font-size: inherit;
  color: ${BLACK};
  text-decoration: none;
  text-align: left;
  border-radius: 8px;
  padding: 1rem;
  font-size: 1rem;
  font-family: 'FigtreeBold', 'sans-serif';
  cursor: pointer;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
  }
`

export const OurProjectsLink = styled(Button)`
  display: block;
  font-size: inherit;
  color: ${WHITE};
  text-decoration: none;
  text-align: left;
  padding: 0.7rem 1rem;
  background-color: ${PRIMARY};
  margin-right: 10px;
  border: none;
  border-radius: 8px;
  position: relative;
  /* width: 100%; */
  font-family: 'FigtreeBold', 'sans-serif';
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }

  &:active {
    color: ${BLACK} !important;
    background-color: ${HOVER_ITEM_COLOR} !important;
    border-color: none !important;
  }

  &:disabled {
    color: ${BLACK} !important;
    background-color: ${HOVER_ITEM_COLOR} !important;
    border-color: none !important;
  }
`

export const ContactUsMenuItemLink = styled.a`
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
  text-align: left;
  padding: 0;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }
`

export const ContactUsDropdownToggle = styled(Dropdown.Toggle)`
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
  text-align: left;
  padding: 0.7rem 1rem;
  background-color: transparent !important;
  border: none;
  font-family: 'FigtreeBold', 'sans-serif';
  border-radius: 8px;
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }

  &:active, &:focus, &:focus-within, &:focus-visible {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR} !important;
    box-shadow: none;
  }
`

export const ContactUsDropdownItem = styled(Dropdown.Item)`
  &:active, &:focus, &:focus-within, &:focus-visible {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    box-shadow: none;
    cursor: pointer;
  }
`

export const MarketplaceMenuItemLink = styled(Link)`
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
  text-align: left;
  padding: 0.7rem 1.5rem;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }
`

export const MarketplaceDropdownToggle = styled(Dropdown.Toggle)`
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
  text-align: left;
  padding: 0.7rem 1rem;
  background-color: transparent !important;
  border: none;
  font-family: 'FigtreeBold', 'sans-serif';
  border-radius: 8px;
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }

  &:active, &:focus, &:focus-within, &:focus-visible {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR} !important;
    box-shadow: none;
  }
`

export const MarketplaceDropdownItem = styled(Dropdown.Item)`
  &:active, &:focus, &:focus-within, &:focus-visible {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    box-shadow: none;
    cursor: pointer;
  }
`

export const ProductsMenuItemLink = styled.a`
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
  text-align: left;
  padding: 0;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }
`

export const ProductsDropdownToggle = styled(Dropdown.Toggle)`
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
  text-align: left;
  padding: 0.7rem 2rem;
  background-color: transparent !important;
  border: none;
  font-family: 'FigtreeBold', 'sans-serif';
  border-radius: 8px;
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }

  &:active, &:focus, &:focus-within, &:focus-visible {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR} !important;
    box-shadow: none;
  }
`

export const ProductsDropdownItem = styled(Dropdown.Item)`
  &:active, &:focus, &:focus-within, &:focus-visible {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
    box-shadow: none;
    cursor: pointer;
  }
`

export const ProductsMenuItemLinkMobile = styled.a`
  display: block;
  font-size: inherit;
  color: ${BLACK};
  text-decoration: none;
  text-align: left;
  padding: 1rem;
  font-size: 1.5rem;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
  }
`

export const OurProjectsLinkMobile = styled(Button)`
  display: block;
  font-size: 1rem !important;
  color: ${WHITE};
  text-decoration: none;
  text-align: left;
  padding: 1rem;
  font-size: 1.5rem;
  /* margin: 1rem 0; */
  background-color: ${PRIMARY};
  border: none;
  width: 100%;
  border-radius: 8px;
  position: relative;
  font-family: 'FigtreeBold', 'sans-serif' !important;
  cursor: pointer !important;

  &:hover {
    color: ${WHITE};
    background-color: ${HOVER_ITEM_COLOR};
  }

  &:active {
    color: ${BLACK} !important;
    background-color: ${HOVER_ITEM_COLOR} !important;
    border-color: none !important;
  }

  &:disabled {
    color: ${BLACK} !important;
    background-color: ${HOVER_ITEM_COLOR} !important;
    border-color: none !important;
  }
`

export const DesktopMenuWrapper = styled.nav`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  justify-content: center;
  @media (max-width: 1070px) {
    display: none;
  }
`

export const MobileMenuWrapper = styled.nav`
  display: none;
  @media (max-width: 1070px) {
    display: unset;
  }
`

export const MenuToggleInput = styled.input`
  display: block;
  width: 40px;
  height: 32px;
  position: absolute;
  top: -7px;
  left: -5px;
  
  cursor: pointer;
  
  opacity: 0; /* hide this */
  z-index: 2; /* and place it over the hamburger */
  
  -webkit-touch-callout: none;
`

export const OverlayBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  transition: opacity 0.5s ease;
`;

export const OverlayPanel = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 40vw;
  background-color: white;
  z-index: 9999;
  padding: 2rem;
  transition: transform 0.5s ease, opacity 0.5s ease;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3);
  transform: translateX(-100%);
  opacity: 0;
  overflow-y: auto;
  font-family: 'FigtreeBold', 'sans-serif';
  background-color: ${BACKGROUND_COLOR};

  &.open {
    transform: translateX(0);
    opacity: 1;
  }

  @media (max-width: 1280px) {
    width: 45vw;
  }

  @media (max-width: 1150px) {
    width: 50vw;
  }

  @media (max-width: 950px) {
    width: 65vw;
  }

  @media (max-width: 768px) {
    width: 100vw;
  }
`;

export const OverlayCloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  /* padding: 0.5rem; */
  cursor: pointer;
  color: #333;
  font-size: 2rem;

  &:hover {
    color: black;
  }
`;

export const OverlayContent = styled.div`
 padding: 3rem 0;
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: -5px;
  right: -10px;
  background-color: red;
  color: ${WHITE};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-family: 'FigtreeBold', 'sans-serif';
`;

export const NotificationBadgeMobile = styled.span`
  position: absolute;
  top: -5px;
  right: 0px;
  background-color: red;
  color: ${WHITE};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-family: 'FigtreeBold', 'sans-serif';
`;